/**
 * Created by Amit
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {TweenParticleEmitter} from "../../coinfountain/TweenParticleEmitter";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {ParticleConfigs} from "../../particles/ParticleConfigs";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";

export class BonusBunniesInitialWPView extends BaseView {

    private _spineSymbols:PIXI.spine.Spine[][];
    private _coinParticles:TweenParticleEmitter;
    private _coinLayer:ScalableLayer;
    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [1050, 1450];
    private readonly _particleMaxLife:number = 2.1;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._coinLayer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);

        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.REEL_ATTENTION.name).addChildAt(this, 0);
        this._spineSymbols = [];
        for(let i:number = 0; i < 4; i++) {
            const reel:PIXI.spine.Spine[] = [];
            for(let j:number = 0; j < 5; j++) {
                const symbol:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("symbol"));
                symbol.position.x = Helper.getSymbolPositions(i, j)[0];
                symbol.position.y = Helper.getSymbolPositions(i, j)[1];
                symbol.visible = false;
                this.addChild(symbol);
                reel.push(symbol);
            }
            this._spineSymbols.push(reel);
        }

        const coinParticleTextures = GameResources.getTextures("bigWinCoin0");
        this._coinParticles = new TweenParticleEmitter(coinParticleTextures, ParticleConfigs.mediumAndLargeWin);
        this._coinLayer.addChild(this._coinParticles);
    }

    public playBronzeCoins(level:number):void {
        this._coinParticles.emitter.maxParticles = ((level === 0) ? 20 : 30);
        this._coinParticles.getAnimation();
    }



    public getSymbolInitialWinTL(symbol:StateReelSymbol, reel:number, row:number, state:string):TimelineLite {
        const symbolInitialWin:TimelineLite = new TimelineLite();
        symbolInitialWin.add(() => this.addChild(this._spineSymbols[reel][row]));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSkin(null));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSkinByName(symbol.symName));
        symbolInitialWin.add(() => this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose());
        symbolInitialWin.add(() => this._spineSymbols[reel][row].updateTransform());
        symbolInitialWin.add(() => this._spineSymbols[reel][row].visible = true);
        symbolInitialWin.add(() => symbol.visible = false, "+=0.05");
        symbolInitialWin.add(new SpineTween(this._spineSymbols[reel][row], 0, state, 0));

        return symbolInitialWin;
    }

    public setSymbolInitialWinNoWin(symbol:StateReelSymbol, reel:number, row:number, state:string):void {
        this._spineSymbols[reel][row].skeleton.setSkin(null);
        this._spineSymbols[reel][row].skeleton.setSkinByName(symbol.symName);
        this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose();
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.disabledSpineSymbolsContainer.addChild(this._spineSymbols[reel][row]);
        this._spineSymbols[reel][row].updateTransform();
        this._spineSymbols[reel][row].visible = true;
        symbol.visible = false;
        this._spineSymbols[reel][row].state.setAnimation(0, state, false);
    }

    //Used by individual win to make sure correct syms are set to win state (if initial win has been skipped)
    public setSymbolToState(symName:string, reel:number, row:number):void{
        this._spineSymbols[reel][row].updateTransform();
        this._spineSymbols[reel][row].visible = true;
        this._spineSymbols[reel][row].skeleton.setSkin(null);
        this._spineSymbols[reel][row].skeleton.setSkinByName(symName);
        this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose();
        //Setting animation to last frame
        const currentAnimationTrackEntry:PIXI.spine.core.TrackEntry = this._spineSymbols[reel][row].state.setAnimation(0, "win_loop", false);
        currentAnimationTrackEntry.trackTime = currentAnimationTrackEntry.animationEnd;
    }

    public getSymbolIndividualWinTL(symbol:StateReelSymbol, reel:number, row:number):TimelineLite {
        const symbolIndividualWin:TimelineLite = new TimelineLite();
        symbolIndividualWin.add(() => this._spineSymbols[reel][row].updateTransform());
        symbolIndividualWin.add(() => this._spineSymbols[reel][row].visible = true);
        symbolIndividualWin.add(() => symbol.visible = false);
        symbolIndividualWin.add(() => this._spineSymbols[reel][row].skeleton.setSkin(null));
        symbolIndividualWin.add(() => this._spineSymbols[reel][row].skeleton.setSkinByName(symbol.symName));
        symbolIndividualWin.add(() => this._spineSymbols[reel][row].skeleton.setSlotsToSetupPose());
        symbolIndividualWin.add(new SpineTween(this._spineSymbols[reel][row], 0, "win_loop", 0));

        return symbolIndividualWin;
    }

    public cleanupSpineWinSymbols():void {
        for(let i:number = 0; i < 4; i++) {
            for(let j:number = 0; j < 5; j++) {
                Reels.getSymbol(i, j)!.visible = true;
                this._spineSymbols[i][j].visible = false;
                //Make sure all spine syms are back in non masked layer
                this.addChild(this._spineSymbols[i][j]);
            }
        }
    }

    protected onResize(resizeData:IResizeData):void {
        this._coinParticles.emitter.spawnPos.y = (resizeData.height - ((resizeData.height - 720) / 2)) + 30;
        let screenHeight = Math.max(this._screenHeightRange[0], Math.min(resizeData.height, this._screenHeightRange[1]));
        this._coinParticles.emitter.maxLifetime = MathHelper.ceilToDecimals(this._particleMaxLife * (resizeData.height / 720), 2);
        this._coinParticles.emitter.startSpeed.value = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
    }

    public abort():void{
        this._coinParticles.stopLoop(true);
    }
}